module.exports = __webpack_public_path__ + "img/img-shousuo@2x.8bf13a30.png";